<template>
  <!-- div#body:start -->
  <div id="body"
    :class="[
    {'is-hidden-header' : targetScrollFlg},
    {'is-visible-menu':_state.visibleMenu},
    {'is-visible-menu-left':_state.visibleMenuLeft}
    ]"
  >
  <BackgroundImage />
  

    <!-- SPメニュー -->
    <SPMenu
      :parentVisibleMenu="_state.visibleMenu"
      @closeMenu="_state.visibleMenu = false"
    />

    <!-- 左ナビ -->
    <div id="menu-left" class="menu-left">
      <ul class="menu-left-list">
        <li v-if="data.tags.length > 0 || data.filterTags.length > 0" class="menu-left-list-item">
          <span class="menu-left-list-item-label"
            @click="_state.visibleSearchConditionAddTagFromPast = true;"
          >タグの絞り込み条件を設定する</span>
        </li>
        <li class="menu-left-list-item">
          <span class="menu-left-list-item-label"
            @click="_state.visibleSearchConditionExtract = true;"
          >絞り込み条件を設定する</span>
        </li>
      </ul>
      <div class="menu-left-close"
        @click="_state.visibleMenuLeft = false"
      >
        <span class="icn-wrap"><FontawesomeIcon :icon="['fal', 'times']" class="icn" /></span>
      </div>
    </div>

    <!-- 検索条件の設定 -->
    <transition name="popup">
      <SPSearchConditionEdit
        v-if="state.visibleSearchConditionEdit"
        @closeSearchConditionEdit="state.visibleSearchConditionEdit = false"
        @save="_state.isOpenMenu = false"
      />
    </transition>

    <!-- 削除 -->
    <transition name="popup">
      <SPSearchConditionDeleteConfirm
        v-if="state.visibleSearchConditionDeleteConfirm"
        @closeSearchConditionDeleteConfirm="state.visibleSearchConditionDeleteConfirm = false;_state.isOpenMenu = false"
      />
    </transition>

    <!-- 絞り込みの設定 -->
    <transition name="popup">
      <SPSearchConditionExtract
        v-if="_state.visibleSearchConditionExtract"
        type="searchCondition"
        @closeSearchConditionExtract="_state.visibleSearchConditionExtract = false"
        @submitSearchConditionExtract="_state.visibleMenuLeft = false"
      />
    </transition>

    <!-- タグの設定 -->
    <transition name="popup">
      <SPSearchConditionAddTagFromPast
        :data="data"
        v-if="_state.visibleSearchConditionAddTagFromPast"
        @closeSearchConditionAddTagFromPast="_state.visibleSearchConditionAddTagFromPast = false"
      />
    </transition>

    <div id="wrapper">

      <div id="menu-btn" class="menu-btn">
        <div role="button" class="menu-btn-2"
          @click="_state.visibleMenu = true;_state.visibleWindowDetail = false"
        >
          <IconMenu class="icn" />
        </div>
      </div>

      <div id="navi-btn" class="navi-btn"
        @click="_state.visibleMenuLeft = true"
      >
        <FontawesomeIcon :icon="['fas', 'ellipsis-v']" class="icn" />
      </div>


      <!-- div#header:start -->
      <div id="header">
        <header class="header">
          <SPButtonHistoryBack />
          <div class="header-title">
            <h1>保存検索条件</h1>
          </div>
        </header>
      </div>

      <!-- div#header:end -->
      <div id="main">
        <div class="main">
          <div class="main-heading">
            <div class="main-heading-row main-heading-result">
              <div v-if="data.count !== null" class="main-heading-result-num">{{data.count}}件</div>
            </div>
          </div>
          <SPScrollList
            :complete="data.complete"
            @bottomDisplayed="action.load"
            @scroll="handleScroll"
            >
            <p v-if="data.complete && data.lists.length <= 0" class="ml20 mt20 txt">検索条件は保存されていません。</p>
            <p v-else-if="data.complete && data.groupDateLists.length <= 0" class="ml20 mt20 txt">絞り込み条件に一致する検索条件は保存されていません。</p>
            <template v-else>
              <template v-for="(dateLists, index) in data.groupDateLists">
                <div :key="'searchCondition_date_' + index" class="date">{{formatDate(index)}}</div>
                <ul :key="'searchCondition_lists_' + index" class="list-result list-result-02">
                  <li v-for="list in dateLists" :key="'date_'+ index + '_list_' + list.id" 
                    class="list-result-item" :class="{'is-menu-visible': _state.isOpenMenu}">
                    <div class="list-result-item-main">
                      <div class="list-result-title"><a @click="action.routeList(list)">{{list.title}}</a></div>
                      <div v-if="list.tags.length > 0" class="list-result-tags">
                        <div v-for="(tag, tagIndex) in list.tags" :key="'tag_' + tagIndex" class="tag">
                          <div class="tag-wrap">
                            <span class="tag-text">{{tag.name}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="list-result-item-sub">
                      <div class="button edit">
                        <button role="button" class="btn"
                          @click="action.editItem(list.id)"
                        >
                          編集
                        </button>
                      </div>
                      <div class="button delete">
                        <button class="btn" type="button"
                          @click="action.deleteItem(list.id)"
                        >
                          <FontawesomeIcon :icon="['far', 'times']" class="icn" />
                        </button>
                      </div>
                    </div>
                    <button class="list-result-item-menu" @click="_state.isOpenMenu = !_state.isOpenMenu">
                      <FontawesomeIcon :icon="['fas', 'ellipsis-v']" class="icn" />
                    </button>
                  </li>
                </ul>
              </template>
            </template>
          </SPScrollList>
        </div>
      </div>


    </div>
  </div>
  <!-- div#body:end -->
</template>

<script>
import { defineComponent, reactive } from '@vue/composition-api'
import { SearchConditionList } from '@/logic/searchCondition/SearchConditionList.js'

import SPMenu from '@/components/sp/popup/SPMenu.vue'
import SPSearchConditionEdit from '@/components/sp/popup/SPSearchConditionEdit.vue'
import SPSearchConditionDeleteConfirm from '@/components/sp/popup/SPSearchConditionDeleteConfirm.vue'
import SPSearchConditionExtract from '@/components/sp/popup/SPSearchConditionExtract.vue'
import SPSearchConditionAddTagFromPast from '@/components/sp/popup/SPSearchConditionAddTagFromPast.vue'
import SPScrollList from '@/components/sp/partial/SPScrollList.vue'


export default defineComponent({
  components: {
    SPMenu,
    SPSearchConditionEdit,
    SPSearchConditionDeleteConfirm,
    SPSearchConditionExtract,
    SPSearchConditionAddTagFromPast,
    SPScrollList
  },
  setup (props, context) {

    const _state = reactive({
      visibleMenu: false,
      visibleSearchConditionExtract: false,
      visibleSearchConditionAddTagFromPast: false,
      visibleMenuLeft: false,
      visibleBasicToastLator: false,
      visibleBasicToastSave: false,
      isOpenMenu: false
    })
   
    return {
      _state,
      ...SearchConditionList(props, context)
    }
  }
})
</script>

<style lang="scss" scoped>
.main {
  &-heading-row {
    height: $sp-main-heading-height;
  }
  &-container {
    @include changeHeightOnScroll($sp-header-height + $sp-main-heading-height);
    background-color: $color-bg-paper;
    .date {
      font-size: 1.4rem;
      color: $color-content;
      padding: 32px 20px;
    }
    .list-result {
      background-color: #fff;
    }
  }
}
.menu-btn {
  &-2 {
    border-top-left-radius: 8px;
    .icn {
      transition: all .2s ease;
    }
    .icn-opened {
      opacity: 0;
    }
    .icn-closed {
      opacity: 1;
    }
  }
}

</style>
